import React from 'react';

import HeaderBanner from './header-banner';
import { useTimedPromotionForClub } from 'src/components/common/promo/use-timed-promotion';

const GlobalTimedBanner: React.FC = () => {
  const { timedPromoActiveForCurrentClub, showGlobalBanner } = useTimedPromotionForClub();

  if (!timedPromoActiveForCurrentClub || !showGlobalBanner) {
    return null;
  }

  const content = timedPromoActiveForCurrentClub.promotionDetails.globalBanner;

  return <HeaderBanner content={content} />;
};

export default GlobalTimedBanner;
